const normalizeMode = (value) => {
  const mode = typeof value === 'string' ? value.toLowerCase() : null;
  if (['accept', 'accepted', 'granted'].includes(mode)) return 'accept';
  if (['reject', 'rejected', 'denied'].includes(mode)) return 'reject';
  if (mode === 'none') return 'none';
  return null;
};

export const consentStateOf = (result = {}) => {
  const conditions = result?.labRunSpread?.conditions || result?.conditions || {};
  const effective = normalizeMode(
    result?.effectiveCmpMode ?? conditions?.effectiveCmpMode
  );
  const requested = normalizeMode(
    result?.requestedCmpMode ?? conditions?.requestedCmpMode ?? result?.cmpMode
  );
  const acceptActionRecorded = result?.cmpClicked === true
    || conditions?.cmpClicked === true
    || result?.skipCmp === true
    || conditions?.skipCmpRequested === true
    || requested === 'accept';
  return { effective, requested, acceptActionRecorded };
};

// Shared by the standard export and both editorial/dashboard variants.
// A click/request is an action, not proof of the resulting vendor state.
export const formatConsentState = (result, language = 'cs', { prefix = true } = {}) => {
  const cs = language === 'cs';
  const state = consentStateOf(result);
  let text;
  if (state.effective === 'accept') {
    text = cs ? 'účinný souhlas pozorován' : 'effective consent observed';
  } else if (state.effective === 'reject') {
    text = cs ? 'účinné odmítnutí pozorováno' : 'effective rejection observed';
  } else if (state.acceptActionRecorded) {
    text = cs
      ? 'akce přijetí zaznamenána; účinný stav neověřen'
      : 'accept action recorded; effective state unverified';
  } else {
    text = cs
      ? 'akce přijetí nezaznamenána; účinný stav neověřen'
      : 'accept action not recorded; effective state unverified';
  }
  return prefix ? `CMP: ${text}` : text;
};